/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from "react";

export default function HelpCenterInfoPage(props) {
  return (
    <div className="mainPage">
      <div className="contentSection">
        <div className="helpCenter mt-2">{props.body}</div>
      </div>
    </div>
  );
}
